import { Component, OnInit, SimpleChanges, Input, ViewChild } from '@angular/core';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LITERALS } from 'src/app/core/constants/literals.constant';
import { UploadImageWarningModalComponent } from '../upload-image-warning-modal/upload-image-warning-modal.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from 'src/app/core/services/auth.service';
import { SuccessMessageComponent } from 'src/app/components/all-modals/success-message/success-message.component';
import { ErrorMessageComponent } from 'src/app/components/all-modals/error-message/error-message.component';


@Component({
  selector: 'app-image-cropper',
  templateUrl: './image-cropper.component.html',
  styleUrls: ['./image-cropper.component.scss']
})
export class ImageCropperComponent implements OnInit {
  imageChangedEvent: any = '';
  croppedImage: any = '';
  croppedEvent: any = '';
  btnDisabled = false;
  isImageLoaded = false;
  @Input() public event;
  @Input() public aspectRatio;
  @Input() public minWidth;
  @Input() public minHeight;
  @Input() public userId;
  @ViewChild('imageCropper', { static: true }) imageCropper: any;

  constructor(
    private activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private _authService: AuthService
  ) {
    this.spinner.show();
  }

  ngOnInit() {
    this.fileChangeEvent(this.event);
  }

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
  }
  imageCropped(event: ImageCroppedEvent) {
    this.croppedEvent = event;
    this.croppedImage = event.base64;

    const file = this.dataURLtoFile(this.croppedImage);
    if (file) {
      this.saveCoverImage(file);
    } else {
      // this.toastr.warning(LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
  }
  startCropImage() {
    this.spinner.show();
  }
  imageLoaded() {
    this.spinner.hide();
    this.isImageLoaded = true;
    this.cropperReady();
  }
  cropperReady() {
    if (this.imageCropper.originalSize && (this.imageCropper.originalSize.width < this.minWidth || this.imageCropper.originalSize.height < this.minHeight)) {
      // this.toastr.warning(LITERALS.AUTH.ERROR_MESSAGES.COVER_IMAGE_ERROR);
      this.btnDisabled = true;
      this.activeModal.close();
      const modalRef = this.modalService.open(UploadImageWarningModalComponent, { centered: true });
      modalRef.componentInstance.minWidth = this.minWidth;
      modalRef.componentInstance.minHeight = this.minHeight;
    }
    this.spinner.hide();
    // cropper ready
  }
  loadImageFailed() {
    // show message
  }
  save() {
    this.spinner.show();
    const _this = this;
    setTimeout(function () {
      _this.imageCropper.crop();
    }, 500);

  }
  dataURLtoFile(dataurl) {

    var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    const filename = this.event.target.files[0].name.split('.');
    return new File([u8arr], filename[0] + '.png', { type: mime });
  }
  closeDialog() {
    this.activeModal.close();
  }

  saveCoverImage(file) {
    if (!this.userId) {
      // this.spinner.hide();
      let params = {
        message: 'success',
        base64: this.croppedImage,
        file: file
      };
      this.activeModal.close(params);
    } else {
      this._authService.updateCoverProfileImage(this.userId, file).subscribe(
        (response: any) => {
          if (response.success) {
            this.spinner.hide();
            let params = {
              message: 'success',
              base64: this.croppedImage
            };
            this.activeModal.close(params);
            const modelRef = this.modalService.open(SuccessMessageComponent, { centered: true });
            modelRef.componentInstance.message = LITERALS.AUTH.SUCCESS_MESSAGES.COVER_UPDATED;
          }
          else if(response.status == 422){
            this.spinner.hide();
            this.activeModal.close();
            const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
            modalRef.componentInstance.message = response.errors;
          } 
        });
    }

  }
}
